import { ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/app/app-context";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  // DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { App } from "@/lib/types";
import { AppLogo } from "@/assets";

export function AppSwitcher() {
  const navigate = useNavigate();
  const { isMobile, state } = useSidebar();
  const { currentApp, setCurrentApp, apps } = useApp();

  const handleClickApp = (app: App) => {
    setCurrentApp(app);
    navigate(app.basePath);
  };

  if (!currentApp) return null;

  return (
    <SidebarMenu>
      <SidebarMenuItem className="flex justify-center">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="w-full data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground
              "
            >
              <AppLogo
                className="rounded-lg"
                style={{ width: "2rem", height: "2rem" }}
              />

              {state === "expanded" && (
                <>
                  <div className="grid flex-1 text-left text-sm leading-tight">
                    <span className="truncate font-semibold">
                      {currentApp.name}
                    </span>
                    <span className="truncate text-xs">
                      {currentApp.plan || "Enterprise"}
                    </span>
                  </div>
                  <ChevronDown className="ml-auto" />
                </>
              )}
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-56 rounded-lg"
            align="start"
            side={isMobile ? "bottom" : "right"}
            sideOffset={4}
          >
            <DropdownMenuLabel className="text-xs text-muted-foreground">
              Apps
            </DropdownMenuLabel>
            {apps.map((app, index) => (
              <DropdownMenuItem
                key={app.name}
                onClick={() => handleClickApp(app)}
                className="cursor-pointer gap-2 p-2"
              >
                <div className="flex items-center justify-center">
                  <AppLogo
                    className="rounded-lg"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                  />
                </div>
                {app.name}
                <DropdownMenuShortcut>⌘{index + 1}</DropdownMenuShortcut>
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
